var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header-box',{key:_vm.isChange,on:{"logout":_vm.logout}}),_vm._v(" "),(_vm.isRouterAlive)?_c('router-view',{key:_vm.$route.path.indexOf('/TaskSublist/') > -1 ? '/TaskSublist/' : _vm.$route.path + _vm.$route.query.t}):_vm._e(),_vm._v(" "),(_vm.bol)?_c('all-btn',{ref:"allBtn"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-123bc356","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 